export default __webpack_public_path__ + "static/media/Bolo-De-Berlim-Custard.d1b07aa5.jpg";